import { ButtonView } from "ckeditor5";
import { css } from "styled-components";

import { IconArrowRightBarLine } from "@examspark/common-ui/dist/components/icons";

import WrapInElementCommand from "../util/WrapInElementCommand";

import { PluginWithStyles } from "./PluginWithStyles";

export const COMMAND_NOWRAP = "nowrap";
export const UI_BUTTON_NOWRAP = "nowrap";
const ELEMENT_NOWRAP = "nowrap";

export class Nowrap extends PluginWithStyles {
  static buildEditorStyles() {
    return css`
      .nowrap {
        ::after {
          content: "⇥";
          padding-left: 0.25em;
        }

        border-bottom: 3px double grey;
      }
    `;
  }

  init() {
    this.editor.model.schema.register(ELEMENT_NOWRAP, {
      allowIn: ["$block", "$content", "$blockObject"],
      allowChildren: "$text",
      isInline: true,
      isContent: true,
      isLimit: true,
    });

    this.editor.editing.view.domConverter.registerInlineObjectMatcher({
      name: "span",
      styles: { "white-space": "nowrap" },
    });

    this.editor.data.htmlProcessor.domConverter.registerInlineObjectMatcher({
      name: "span",
      styles: { "white-space": "nowrap" },
    });

    this.editor.conversion.for("upcast").elementToElement({
      model: ELEMENT_NOWRAP,
      view: {
        name: "span",
        styles: { "white-space": "nowrap" },
      },
    });

    this.editor.conversion.for("dataDowncast").elementToElement({
      model: ELEMENT_NOWRAP,
      view: {
        name: "span",
        styles: { "white-space": "nowrap" },
      },
    });

    this.editor.conversion.for("editingDowncast").elementToElement({
      model: ELEMENT_NOWRAP,
      view: {
        name: "span",
        styles: { "white-space": "nowrap" },
        classes: "nowrap",
      },
    });

    const command = new WrapInElementCommand(this.editor, ELEMENT_NOWRAP, true);
    this.editor.commands.add(COMMAND_NOWRAP, command);

    this.editor.ui.componentFactory.add(UI_BUTTON_NOWRAP, (locale) => {
      const button = new ButtonView(locale);
      button.set({
        icon: IconArrowRightBarLine.Content,
        tooltip: "Non-Wrapping",
      });

      button.on("execute", () => {
        command.execute();
        this.editor.editing.view.focus();
      });
      button.bind("isEnabled", "isOn").to(command, "isEnabled", "value");

      return button;
    });
  }
}
